import rows from "./screens.json" with { type: "json" };
export type AppKind = "storefront" | "vendor" | "admin";
export const screens = rows;
export function appScreens(kind: AppKind) {
  return rows.filter((s) =>
    kind === "storefront"
      ? ["buyer", "account", "integrator"].includes(s.role)
      : kind === "vendor"
        ? s.role === "seller"
        : s.role === "operator",
  );
}
export function matchRoute(kind: AppKind, path: string) {
  return appScreens(kind).find((s) =>
    new RegExp(
      "^" +
        s.route
          .replace(/\[locale\]/g, "(?:en|es|fr|de|ja|ar|he)")
          .replace(/\[(?:id|slug)\]/g, "[^/]+") +
        "/?$",
    ).test(path),
  );
}
export function routeHref(template: string, locale: string, id?: string) {
  if (/\[(id|slug)\]/.test(template) && !id) return undefined;
  return template
    .replace("[locale]", locale)
    .replace(/\[(?:id|slug)\]/g, encodeURIComponent(id || ""));
}
export function localeFor(path: string): "en" | "es" | "fr" | "de" | "ja" {
  const l = path.split("/")[1];
  return ["en", "es", "fr", "de", "ja"].includes(l) ? (l as "en") : "en";
}
